import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-prescription-selected",
  "use": "icon-prescription-selected-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-prescription-selected\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 1024C229.239467 1024 0 794.760533 0 512 0 229.239467 229.239467 0 512 0c282.760533 0 512 229.239467 512 512 0 282.760533-229.239467 512-512 512z m325.870933-700.142933a49.595733 49.595733 0 0 0-74.274133 0L433.152 681.813333l-172.9536-187.357866a49.732267 49.732267 0 0 0-74.24 0 60.416 60.416 0 0 0 0 80.4864l210.056533 227.566933a50.517333 50.517333 0 0 0 37.137067 16.622933c13.4144 0 26.862933-5.563733 37.137067-16.622933l367.581866-398.267733c20.48-22.186667 20.48-58.197333 0-80.384z\" p-id=\"12324\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/prescription-selected.svg
// module id = ikui
// module chunks = 11